module.exports = __webpack_public_path__ + "img/scene-entry-banner-6.436f9b94.png";